import { FC, useRef, useEffect } from 'react';
import { Box } from '@mui/material';

import useSport from 'store/sport';
import useCurrentUser from 'store/currentUser';
import SectionLoader from 'components/sections/SectionLoader/SectionLoader';

declare const LuckySports: {
  new (): {
    init(config: {
      target: HTMLElement | null;
      token: string;
      options: {
        is9WLayout: boolean;
        displayHeader: boolean;
        isSouthAsia: boolean;
        displayBalance: false;
        offsetTop: number;
        offsetBottom: number;
      };
    }): void;
  };
};

type Props = {
  sportId: string;
};

const LuckySportsPage: FC<Props> = ({ sportId }) => {
  const lsRef = useRef(null);
  const [sportState] = useSport();
  const [userState] = useCurrentUser();
  const userExists = !!userState.data.id;

  const handleLoad = () => {
    if (lsRef.current) return;
    const { access_token } = sportState.data[sportId];
    lsRef.current = new LuckySports().init({
      target: document.getElementById('sport-root'),
      token: access_token,
      options: {
        is9WLayout: true,
        displayHeader: false,
        displayBalance: false,
        isSouthAsia: true,
        offsetTop: 0.1,
        offsetBottom: 0.1,
      },
    });
  };

  useEffect(() => {
    if (!sportState.data[sportId]) {
      return;
    }

    (async () => {
      if (!document.getElementById('sport-root-external-css')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://sprodm.uni247.xyz/dist/style.css';
        link.id = 'sport-root-external-css';
        document.head.appendChild(link);
      }

      if (!document.getElementById('sport-root-external-js')) {
        const script = document.createElement('script');
        script.src = 'https://sprodm.uni247.xyz/dist/LuckySports.es.js';
        script.type = 'text/javascript';
        script.id = 'sport-root-external-js';
        script.type = 'module';
        script.onload = handleLoad;
        document.body.appendChild(script);
      }
    })();
  }, [sportState.data[sportId]]);

  useEffect(() => {
    if (lsRef.current && sportState.data[sportId]) {
      const { access_token } = sportState.data[sportId];
      lsRef.current?.kill();
      lsRef.current = new LuckySports().init({
        target: document.getElementById('sport-root'),
        token: access_token,
        options: {
          is9WLayout: true,
          displayHeader: false,
          displayBalance: false,
          isSouthAsia: true,
          offsetTop: 0.1,
          offsetBottom: 0.1,
        },
      });
    }
  }, [userExists, sportState.data[sportId]]);

  useEffect(() => {
    return () => {
      lsRef.current?.kill();
      const existingLink = document.getElementById('sport-root-external-css');
      const existingScript = document.getElementById('sport-root-external-js');
      if (existingLink) {
        existingLink.parentNode.removeChild(existingLink);
      }
      if (existingScript) {
        existingScript.parentNode.removeChild(existingScript);
      }
    };
  }, []);

  if (!sportState.data[sportId]) return <SectionLoader />;

  return (
    <Box width="100%" minHeight="calc(100vh - 126px)" maxHeight="calc(100vh - 126px)" sx={{ overflow: 'auto' }}>
      <div id="sport-root"></div>
    </Box>
  );
};

export default LuckySportsPage;
